// import { Component } from 'react';
import { useState } from 'react';
import CafeFeedbackStatistics from 'components/CafeFeedbackStatistics/CafeFeedbackStatistics';
import CafeFeedbackOptions from 'components/CafeFeedbackOptions/CafeFeedbackOptions';
import CafeFeedbackTitle from 'components/CafeFeedbackTitle/CafeFeedbackTitle';
import CafeFeedbackNotification from 'components/CafeFeedbackNotification/CafeFeedbackNotification';
import { Container } from 'components/App/App.styled';

export default function App() {
  const [good, setGood] = useState(0);
  const [neutral, setNeutral] = useState(0);
  const [bad, setBad] = useState(0);

  const feedbackTypes = ['good', 'neutral', 'bad'];

  const handleFeedback = type => {
    switch (type) {
      case 'good':
        setGood(prevGood => prevGood + 1);
        break;

      case 'neutral':
        setNeutral(prevNeutral => prevNeutral + 1);
        break;

      case 'bad':
        setBad(prevBad => prevBad + 1);
        break;

      default:
        console.warn(`Тип поля - ${type} не обрабатывается`);
    }
  };

  const countTotalFeedback = () => {
    return good + neutral + bad;
  };

  const countPositiveFeedbackPercentage = () => {
    const total = countTotalFeedback();
    return total > 0 ? `${Math.round((good / total) * 100)}%` : '0%';
  };

  const resetCafeFeedback = () => {
    setGood(0);
    setNeutral(0);
    setBad(0);
  };

  return (
    <Container>
      <CafeFeedbackTitle title="Please leave feedback">
        <CafeFeedbackOptions
          options={feedbackTypes}
          onLeaveFeedback={handleFeedback}
          showReset={!!countTotalFeedback()}
          onReset={resetCafeFeedback}
        />
      </CafeFeedbackTitle>

      <CafeFeedbackTitle title="Statistics">
        {countTotalFeedback ? (
          <CafeFeedbackStatistics
            good={good}
            neutral={neutral}
            bad={bad}
            total={countTotalFeedback()}
            positivePercentage={countPositiveFeedbackPercentage()}
          />
        ) : (
          <CafeFeedbackNotification message="There is no feedback"></CafeFeedbackNotification>
        )}
      </CafeFeedbackTitle>
    </Container>
  );
}
